import { Injectable } from '@angular/core';
import { NodeModel } from 'src/app/models/node';
import { AngularFirestore, AngularFirestoreCollection, QueryFn } from '@angular/fire/compat/firestore';
import { Observable, map } from 'rxjs';

import { COLLECTION_NAMES } from './constants';

@Injectable({
  providedIn: 'root',
})
export class NodesService {
  private nodesCollectionQuery: (ref: QueryFn) => AngularFirestoreCollection<NodeModel>;
  private nodesCollection: AngularFirestoreCollection<NodeModel>;

  constructor(afs: AngularFirestore) {
    this.nodesCollectionQuery = (ref: QueryFn) => afs.collection<NodeModel>(COLLECTION_NAMES.NODES, ref);
    this.nodesCollection = afs.collection<NodeModel>(COLLECTION_NAMES.NODES);
  }

  getNodesByBotId(botId: string): Observable<NodeModel[]> {
    const collection = this.nodesCollectionQuery(ref => ref.where('botId', '==', botId));
    return collection.valueChanges({ idField: 'id' }).pipe(map(results => results.sort((a, b) => (a.name > b.name ? 1 : -1))));
  }

  async getNodesByBotIds(botIds: string[]) {
    return this.nodesCollection.ref.where('botId', 'in', botIds).get();
  }

  async deleteNodeById(nodeId: string) {
    return await this.nodesCollection.doc(nodeId).delete();
  }
}
